package one.healthium.health_log.ui

sealed interface HealthLogEvent {
    data object OnHealthLogSaved : HealthLogEvent
}